module.exports = __webpack_public_path__ + "images/icons_v2/thumbs-up-outlined-7f559248.svg";